import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * `<nb-wizard-steps>` — the vertical step list of a wizard (Mockup `.wizsteps`).
 *
 * Renders a real ordered list (`<ol>`) so the steps form a semantic, numbered
 * sequence for assistive tech. Project `<nb-wizard-step>` children; each renders
 * as a list item. Give the list an accessible name via `ariaLabel` (it gets
 * `role="list"` to keep the list semantics when `list-style:none` is applied).
 *
 * @example
 * <nb-wizard-steps ariaLabel="Registrering">
 *   <nb-wizard-step [index]="1" state="done" title="Konto" />
 *   <nb-wizard-step [index]="2" state="current" title="Profil" />
 *   <nb-wizard-step [index]="3" state="todo" title="Bekreft" />
 * </nb-wizard-steps>
 */
@Component({
  selector: 'nb-wizard-steps',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'wizsteps',
    role: 'list',
    '[attr.aria-label]': 'ariaLabel() || null',
  },
  template: `<ng-content />`,
  styleUrl: './wizard.css',
})
export class NbWizardSteps {
  /** Accessible name for the step list (e.g. the wizard's title). */
  readonly ariaLabel = input<string>();
}
